import { Slide } from "packages/lesson/dist/@types";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "Consider the three cavities with analytical solutions for the eigenmodes: parallelepipedic (23 cm x 19 cm x 35 cm),  cylindrical (R = 10 cm, H = 20 cm) and spherical cavities (R = 10 cm). When the cavity presents symmetries (it is the case here for cylindrical and spherical cavities), some modes have the same natural frequency and are said to be degenerate. Each proper mode is associated to three indices (m, n, p) related to the three dimensions (x,y,z), (θ,r,z) or (φ,θ,r) for the parallelepipedic, cylindrical or spherical cavity, respectively. For each mode and cavity type, look at the pressure distribution and the degeneracies.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [1, 5],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "<b>Spherical cavities</b>",
                  formatter: "html",
                  scrollbars: false,
                  styles: {
                    justifyContent: "center",
                    fontWeight: 800,
                    letterSpacing: "0.25em",
                    textTransform: "uppercase",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "layout",
            data: {
              type: "custom012002",
              options: {
                data: {
                  cut: {
                    "000": `${config.ASSETS_URL}/01/20/principle/spherical-cut-m0-n0-p0.png`,
                    "001": `${config.ASSETS_URL}/01/20/principle/spherical-cut-m0-n0-p1.png`,
                    "002": `${config.ASSETS_URL}/01/20/principle/spherical-cut-m0-n0-p2.png`,
                    "010": `${config.ASSETS_URL}/01/20/principle/spherical-cut-m0-n1-p0.png`,
                    "011": `${config.ASSETS_URL}/01/20/principle/spherical-cut-m0-n1-p1.png`,
                    "012": `${config.ASSETS_URL}/01/20/principle/spherical-cut-m0-n1-p2.png`,
                    "020": `${config.ASSETS_URL}/01/20/principle/spherical-cut-m0-n2-p0.png`,
                    "021": `${config.ASSETS_URL}/01/20/principle/spherical-cut-m0-n2-p1.png`,
                    "022": `${config.ASSETS_URL}/01/20/principle/spherical-cut-m0-n2-p2.png`,
                    "110": `${config.ASSETS_URL}/01/20/principle/spherical-cut-m1-n1-p0.png`,
                    "111": `${config.ASSETS_URL}/01/20/principle/spherical-cut-m1-n1-p1.png`,
                    "112": `${config.ASSETS_URL}/01/20/principle/spherical-cut-m1-n1-p2.png`,
                    "120": `${config.ASSETS_URL}/01/20/principle/spherical-cut-m1-n2-p0.png`,
                    "121": `${config.ASSETS_URL}/01/20/principle/spherical-cut-m1-n2-p1.png`,
                    "122": `${config.ASSETS_URL}/01/20/principle/spherical-cut-m1-n2-p2.png`,
                    "220": `${config.ASSETS_URL}/01/20/principle/spherical-cut-m2-n2-p0.png`,
                    "221": `${config.ASSETS_URL}/01/20/principle/spherical-cut-m2-n2-p1.png`,
                    "222": `${config.ASSETS_URL}/01/20/principle/spherical-cut-m2-n2-p2.png`,
                    "-110": `${config.ASSETS_URL}/01/20/principle/spherical-cut-m-1-n1-p0.png`,
                    "-111": `${config.ASSETS_URL}/01/20/principle/spherical-cut-m-1-n1-p1.png`,
                    "-112": `${config.ASSETS_URL}/01/20/principle/spherical-cut-m-1-n1-p2.png`,
                    "-120": `${config.ASSETS_URL}/01/20/principle/spherical-cut-m-1-n2-p0.png`,
                    "-121": `${config.ASSETS_URL}/01/20/principle/spherical-cut-m-1-n2-p1.png`,
                    "-122": `${config.ASSETS_URL}/01/20/principle/spherical-cut-m-1-n2-p2.png`,
                    "-220": `${config.ASSETS_URL}/01/20/principle/spherical-cut-m-2-n2-p0.png`,
                    "-221": `${config.ASSETS_URL}/01/20/principle/spherical-cut-m-2-n2-p1.png`,
                    "-222": `${config.ASSETS_URL}/01/20/principle/spherical-cut-m-2-n2-p2.png`,
                  },
                  full: {
                    "000": `${config.ASSETS_URL}/01/20/principle/spherical-full-m0-n0-p0.png`,
                    "001": `${config.ASSETS_URL}/01/20/principle/spherical-full-m0-n0-p1.png`,
                    "002": `${config.ASSETS_URL}/01/20/principle/spherical-full-m0-n0-p2.png`,
                    "010": `${config.ASSETS_URL}/01/20/principle/spherical-full-m0-n1-p0.png`,
                    "011": `${config.ASSETS_URL}/01/20/principle/spherical-full-m0-n1-p1.png`,
                    "012": `${config.ASSETS_URL}/01/20/principle/spherical-full-m0-n1-p2.png`,
                    "020": `${config.ASSETS_URL}/01/20/principle/spherical-full-m0-n2-p0.png`,
                    "021": `${config.ASSETS_URL}/01/20/principle/spherical-full-m0-n2-p1.png`,
                    "022": `${config.ASSETS_URL}/01/20/principle/spherical-full-m0-n2-p2.png`,
                    "110": `${config.ASSETS_URL}/01/20/principle/spherical-full-m1-n1-p0.png`,
                    "111": `${config.ASSETS_URL}/01/20/principle/spherical-full-m1-n1-p1.png`,
                    "112": `${config.ASSETS_URL}/01/20/principle/spherical-full-m1-n1-p2.png`,
                    "120": `${config.ASSETS_URL}/01/20/principle/spherical-full-m1-n2-p0.png`,
                    "121": `${config.ASSETS_URL}/01/20/principle/spherical-full-m1-n2-p1.png`,
                    "122": `${config.ASSETS_URL}/01/20/principle/spherical-full-m1-n2-p2.png`,
                    "220": `${config.ASSETS_URL}/01/20/principle/spherical-full-m2-n2-p0.png`,
                    "221": `${config.ASSETS_URL}/01/20/principle/spherical-full-m2-n2-p1.png`,
                    "222": `${config.ASSETS_URL}/01/20/principle/spherical-full-m2-n2-p2.png`,
                    "-110": `${config.ASSETS_URL}/01/20/principle/spherical-full-m-1-n1-p0.png`,
                    "-111": `${config.ASSETS_URL}/01/20/principle/spherical-full-m-1-n1-p1.png`,
                    "-112": `${config.ASSETS_URL}/01/20/principle/spherical-full-m-1-n1-p2.png`,
                    "-120": `${config.ASSETS_URL}/01/20/principle/spherical-full-m-1-n2-p0.png`,
                    "-121": `${config.ASSETS_URL}/01/20/principle/spherical-full-m-1-n2-p1.png`,
                    "-122": `${config.ASSETS_URL}/01/20/principle/spherical-full-m-1-n2-p2.png`,
                    "-220": `${config.ASSETS_URL}/01/20/principle/spherical-full-m-2-n2-p0.png`,
                    "-221": `${config.ASSETS_URL}/01/20/principle/spherical-full-m-2-n2-p1.png`,
                    "-222": `${config.ASSETS_URL}/01/20/principle/spherical-full-m-2-n2-p2.png`,
                  },
                },
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
